import { ModalType, useModalContext } from 'modules/campaigns/editor/context';
import { PrimaryButton, BUTTON_SIZES } from 'ui/button';
import { Start } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const ReActivateCampaignAction = () => {
  const { openModal } = useModalContext();

  return (
    <CampaignPermissionCheck action="reactivate" ChildWrapper={CampaignPopover}>
      <PrimaryButton
        data-test="reactivate-button"
        size={BUTTON_SIZES.LARGE}
        onClick={() => openModal(ModalType.ActivateCampaignModal)}
      >
        <Start height={20} />
        Reactivate campaign
      </PrimaryButton>
    </CampaignPermissionCheck>
  );
};
